import React from 'react';
import PrintQR from './pages/PrintQR';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ConferenceForm from './pages/ConferenceForm';
import Conference from './pages/Conference';
import Present from './pages/Present';
import ProgramPage from './pages/ProgramPage';
import DownloadPage from './pages/DownloadPage';

const App = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/p/:token" element={<ProgramPage />} />
            <Route path="/d/:token" element={<DownloadPage />} />
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/conference/new" element={<PrivateRoute><ConferenceForm /></PrivateRoute>} />
            <Route path="/conference/:id" element={<PrivateRoute><Conference /></PrivateRoute>} />
            <Route path="/conference/:id/edit" element={<PrivateRoute><ConferenceForm /></PrivateRoute>} />
            <Route path="/conference/:id/present" element={<PrivateRoute><Present /></PrivateRoute>} />
            <Route path="/conference/:id/print" element={<PrivateRoute><PrintQR /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
